/* src/app/shared/components/ag-tags-input/ag-tags-input.component.scss */
.main-container {
  height: auto;
  min-height: 56px;
  background-color: #f2f2f2;
  padding: 8px 16px;
  position: relative;
  width: 99%;
  border-radius: 12px;
  font-size: 14px;
  overflow: visible;
  float: left;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
}
.main-container-focused {
  height: auto;
  min-height: 56px;
  background-color: #ffffff;
  border: 1px solid #dfdfdf;
  padding: 8px 16px;
  position: relative;
  width: 99%;
  border-radius: 12px;
  font-size: 14px;
  overflow: visible;
  float: left;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  cursor: text;
}
.tag-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  width: 99%;
}
.tag {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  min-width: fit-content;
  padding: 4px 8px 4px 8px;
  background-color: #e4d7f3;
  border-radius: 8px;
  font-family: "Poppins-Medium";
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
  color: #222222;
}
.input {
  height: 24px;
  flex: 1;
  float: right;
  font-size: 14px;
  border: none;
  background-color: #f2f2f2;
}
.input-focused {
  height: 24px;
  flex: 1;
  float: right;
  font-size: 14px;
  border: none;
  outline: none;
  background-color: #ffffff;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
  color: #222222;
}
:-ms-input-placeholder {
  font-family: "Poppins-Regular";
  font-size: 14px;
  line-height: 24px;
  color: #a6a6a6;
}
::placeholder {
  font-family: "Poppins-Regular";
  font-size: 14px;
  line-height: 24px;
  color: #a6a6a6;
}
.permanent-main-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 12px 24px;
  border-bottom: 1px solid #dfdfdf;
}
.tag-section {
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
}
.queue-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 20px;
  border-radius: 12px;
  background-color: #f2f2f2;
}
.queue-container .queue-img {
  height: 24px;
  width: 24px;
  filter: brightness(0) saturate(100%) invert(65%);
}
.permanent-tag {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  min-width: fit-content;
  padding: 4px 8px 4px 8px;
  background-color: #f2f2f2;
  border-radius: 8px;
  font-family: "Poppins-Medium";
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
  color: #222222;
}
.button-container {
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
}
.button-container .button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 12px;
  background-color: #f2f2f2;
  border-radius: 12px;
}
.initials {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #f2f2f2;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Poppins-Regular";
  font-size: 12px;
  font-style: normal;
  line-height: 16px;
  color: #a6a6a6;
}
.guest-tag {
  min-width: fit-content;
  padding: 4px 8px 4px 8px;
  background-color: #f2f2f2;
  border-radius: 8px;
  font-family: "Poppins-Medium";
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
  color: #222222;
}
.error {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  font-family: "Poppins-Medium";
  font-size: 12px;
  font-style: normal;
  line-height: 18px;
  color: #e55e5e;
}
.error-message {
  height: 12px;
  width: 12px;
  filter: brightness(0) saturate(100%) invert(61%) sepia(69%) saturate(2913%) hue-rotate(318deg) brightness(89%) contrast(102%);
}
/*# sourceMappingURL=ag-tags-input.component.css.map */
